import React from 'react';
import { Table } from './ListReleaseNotesTable';
import { deletePostApi } from '../../../../api/post';
import { getAccessTokenApi } from '../../../../api/auth';
import { errorModal, successModal, warningModal } from '../../../Alerts/Alerts';
import Swal from 'sweetalert2';

export default function ListReleaseNotes(props) {
    const { releaseNotes, addPost, editPost, setReloadReleaseNotes } = props;

    const deletePost = post => {
      const accessToken = getAccessTokenApi();

      Swal.fire({
        title: 'Eliminando publicación',
        text: "¿Estas seguro de eliminar la publicación?",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Eliminar'
      }).then((result) => {
        if (result.value) {
          deletePostApi(accessToken, post._id)
          .then(response => {
            if(response.code ===200){
              successModal("", response.message);
              setReloadReleaseNotes(true);
            }else{
              warningModal("Advertencia", response.message);
            }
          })
          .catch(err => {
            errorModal	("Error", err);
          })
        }
      })
    };

    return (
        <div>
            <div className="col-12">
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-8">
                                <h1 className="h3 mb-4 text-gray-800">Mantenedor Release Notes</h1>
                            </div>
                            <div className="col-4 text-right">
                                <button className="btn btn-success" onClick={addPost}>
                                Nueva Release Notes
                                </button>
                            </div>
                        </div>
                        <div className="row">

                            <Table data={releaseNotes} onClickEliminar={deletePost} onClickEditar={editPost} />

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
